import React, { Component, useEffect, useState } from 'react';
import Select from 'react-select';
import { ListButton, usePermissions, useResourceContext } from 'react-admin';
import { Papa, getLocalStorageKey } from '../common/common';

import { RUN_TIME_API_ENDPOINT, CommonHeaderOption, DigitalOrderSystem, EmptyPagination } from '../common/common';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const SoAppNotificationCreate = () => {
  const navigate = useNavigate();
  const permissions = usePermissions();
  const resources = useResourceContext()

  const [showLoader, setShowLoader] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const [validationTitleError, setValidationTitleError] = useState(false);
  const [validationPurposeError, setValidationPurposeError] = useState(false);
  const [validateDescriptionError, setValidateDescriptionError] = useState(false);
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
  const [errorMsg, setErrorMsg] = useState(false);
  const [errorMsgText, setErrorMsgText] = useState(null);
  const [type, setType] = useState('Country');
  const [saleOffNameSapCode, setSaleOffNameSapCode] = useState([]);
  const [parsedCSVdata, setParsedCSVdata] = useState([]);
  const [descCharLeft, setDescCharLeft] = useState(500);
  const [descMaxChar, setDescMaxChar] = useState(500);
  const [unregisteredRetailers, setUnregisteredRetailers] = useState([]);
  const [pasrsedSimilarDataLength, setPasrsedSimilarDataLength] = useState(0);
  const [pasrsedDifferentDataLength, setPasrsedDifferentDataLength] = useState(0);
  const [unregisteredRetailersToggle, setUnregisteredRetailersToggle] = useState(false);
  const [saleOffList, setSaleOffList] = useState([]);
  const [soAppPurpose, setSoAppPurpose] = useState('');
  const [soAppDescription, setSoAppDescription] = useState('');
  const [soAppTitle, setSoAppTitle] = useState('');
  const [originalList, setOriginalList] = useState([]);
  
  useEffect(() => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = 'GET';
    fetch(`${apiUrl}/so_list`, options)
      .then(res => {
        return res.json();
      }).then(jsonD => {
        console.log('jsonD ===>', jsonD)
        let obj = {};
        obj.sap_order_materials = jsonD.data;
        obj.loadingShow = false;
        // console.log('obj==>', obj);
        setOriginalList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label + ' ' + item.email, 'email': item.email.trim() })))
        setSaleOffNameSapCode(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label + ' ' + item.email, 'email': item.email.trim() })))
        // this.setState({
        //   originalList: obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label + ' ' + item.email, 'email': item.email.trim() })),
        //   saleOffNameSapCode: obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label + ' ' + item.email, 'email': item.email.trim() })),
        // });
      });
  }, [])

  const handleChange = e => {
    console.log('hiiii', e);
    console.log('saleOffNameSapCode in handleChange', saleOffNameSapCode);
    const arr = [...originalList]

    let result = arr && arr.filter(item => e && e.filter(i => i.id === item.id).length === 0);
    if (e === null) {
      result = [...originalList];
      setSaleOffList([]);
    }
    // console.log('result', result)
    setSaleOffList(e);
    setSaleOffNameSapCode(result);
    //this.setState({
     // saleOffList: e,
      //saleOffNameSapCode: result

    //});
  };

  const titleChange = (e) => {
    console.log('e >>>>>>>>>', e.target.value);
    if (e.target.value === '' || e.target.value === undefined || e.target.value === null || !e.target.value.trim().length) {
      setValidationError(true);
      setValidationTitleError(true);
      // this.setState({
      //   validationError: true,
      //   validationTitleError: true
      // });
    } else {
      setValidationError(false);
      setValidationTitleError(false);
      // this.setState({
      //   validationError: false,
      //   validationTitleError: false
      // });
    }
    setSoAppTitle(e.target.value)
    // this.setState({ SoAppTitle: e.target.value });
  };

  const purposeChange = (e) => {
    console.log('e >>>>>>>>>', e.target.value);
    if (e.target.value === '' || e.target.value === undefined || e.target.value === null || !e.target.value.trim().length) {
      setValidationError(true);
      setValidationPurposeError(true);
      // this.setState({
      //   validationError: true,
      //   validationPurposeError: true});
    } else {
      setValidationError(false);
      setValidationPurposeError(false);
      // this.setState({
      //   validationError: false,
      //   validationPurposeError: false});
    }
    setSoAppPurpose(e.target.value);
    // this.setState({ SoAppPurpose: e.target.value });
  };

  const selectHandleChange = (event) => {
    setType(event.target.value)
    // this.setState({ type: event.target.value });
  }

  const descriptionChange = (e) => {
    console.log('e >>>>>>>>>', e.target.value);
    const charCount = e.target.value.length;
    const maxChar = descMaxChar;
    const charLength = maxChar - charCount;

    if (e.target.value === '' || e.target.value === undefined || e.target.value === null || !e.target.value.trim().length) {
      setValidationError(true);
      setValidateDescriptionError(true);
      setDescCharLeft(charLength)
      // this.setState({
      //   validationError: true,
      //   validateDescriptionError: true,
      //   descCharLeft: charLength
      // });
    } else {
      setValidationError(false);
      setValidateDescriptionError(false);
      setDescCharLeft(charLength)
      // this.setState({
      //   validationError: false,
      //   validateDescriptionError: false,
      //   descCharLeft: charLength
      // });
    }
    setSoAppDescription(e.target.value)
    // this.setState({ SoAppDescription: e.target.value });

  };

  const formSave = () => {
    setShowLoader(true);
    setSaveButtonDisabled(false);
    // this.setState({
    //   showLoader: true,
    //   saveButtonDisabled: false

    // });
    const formData = {
      title: soAppTitle.trim(),
      description: soAppDescription.trim(),
      type: type,
      name_email: saleOffList,
      purpose: soAppPurpose.trim(),

    }
    console.log('formData>>>>>>', formData);

    const apiUrl = RUN_TIME_API_ENDPOINT;
    const options = CommonHeaderOption();
    options.method = 'POST';
    options.body = JSON.stringify({ formData });

    return fetch(`${apiUrl}/so_in_app_notifications`, options)
      .then(res => {
        console.log('res12...........', res)
        if (res) {
          return res.json();
        }
      }
      )
      .then(res => {
        if (res.errorMsg) {
          setErrorMsg(true);
          setShowLoader(false);
          setErrorMsgText(res.errorMsg);
          // this.setState({
          //   errorMsg: true,
          //   showLoader: false,
          //   errorMsgText: res.errorMsg
          // });
          setTimeout(() => {
            setErrorMsg(false);
            setSaveButtonDisabled(true);
            // this.setState({
            //   errorMsg: false,
            //   saveButtonDisabled: true
            // });
          }, 3000)
        } else {
          console.log('res...........', res)
          setShowLoader(false);
          setSaveButtonDisabled(true);
          setSuccessMsg(true);
          // this.setState({
          //   showLoader: false,
          //   saveButtonDisabled: true,
          //   successMsg: true
          // });
          setTimeout(() => {
            setSuccessMsg(false);
            // this.setState({ successMsg: false });
          }, 2000)
          setTimeout(() => {
            navigate("/so_in_app_notifications");
          }, 3000)
          console.log('res', res);
        }

      }).catch(error => {
        console.log(error);
      })

  }

  const handleFile = e => {
    let file = null;
    file = e.target.files[0];
    const fileType = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
    if (file === null || typeof (file) === 'undefined' || file === '' || typeof (file) === undefined || fileType.toLowerCase() !== 'csv') {
      Swal.fire({
        text: 'Please choose a valid .csv file.',
        confirmButtonText: `OK`,
        icon: 'error'
      });
      file = null;
      console.log('bad file');
    } else {
      console.log([e.target.name], e.target.files[0]);
      setUnregisteredRetailers([]);
      setPasrsedSimilarDataLength(0);
      setPasrsedDifferentDataLength(0);
      // this.setState({
      //   unregisteredRetailers: [],
      //   pasrsedSimilarDataLength: 0,
      //   pasrsedDifferentDataLength: 0,
      // });
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          const checkValidHeader = Object.keys(results.data[0]);
          // console.log('results======>', Object.keys(results.data[0]).includes('COMPANYNAME'));
          if (checkValidHeader.includes('COMPANYNAME') && checkValidHeader.includes('EMAIL')) {
            const parseddata = results.data.map((item, i) => ({ id: i, value: item.COMPANYNAME + ' ' + item.EMAIL, label: item.COMPANYNAME + ' ' + item.EMAIL, email: item.EMAIL.trim() }));
            console.log(parseddata);
            let pasrsedSimilarData = [];
            pasrsedSimilarData = originalList.filter(a1 => parseddata.some(a2 => a1.email === a2.email));
            if (pasrsedSimilarData && pasrsedSimilarData.length) {
              const similarArray = saleOffList !== null ? saleOffList.filter(({ email: id1 }) =>
                !pasrsedSimilarData.some(({ email: id2 }) => id2 === id1)) : [];
                setSaleOffList([...similarArray, ...pasrsedSimilarData]);
                setPasrsedSimilarDataLength(pasrsedSimilarData.length);
                // this.setState({ saleOffList: [...similarArray, ...pasrsedSimilarData], pasrsedSimilarDataLength: pasrsedSimilarData.length })
            }
            const pasrsedDifferentData = parseddata.filter(a1 => pasrsedSimilarData.every(a2 => a1.email !== a2.email));
            if (pasrsedDifferentData && pasrsedDifferentData.length) {
              console.log(pasrsedDifferentData, pasrsedDifferentData.length)
              setUnregisteredRetailers([...pasrsedDifferentData])
              setPasrsedDifferentDataLength(pasrsedDifferentData.length);
              // this.setState({ unregisteredRetailers: [...pasrsedDifferentData], pasrsedDifferentDataLength: pasrsedDifferentData.length })
            }
            console.log('seprated', pasrsedSimilarData, pasrsedDifferentData);
            setParsedCSVdata([...parseddata])
            // this.setState({ parsedCSVdata: [...parseddata] });
          } else {
            file = null;
            Swal.fire({
              text: 'File headers do not match. Kindly download and refer the sample file.',
              confirmButtonText: `OK`,
              icon: 'error'
            });
          }
        }
      });
    }
  }

  const cancelClick = () => {
    setSaleOffList([]);
    setSaleOffNameSapCode(originalList);
    setUnregisteredRetailers([]);
    setPasrsedSimilarDataLength(0);
    setPasrsedDifferentDataLength(0);
    // this.setState({
    //   saleOffList: [],
    //   saleOffNameSapCode: this.state.originalList,
    //   unregisteredRetailers: [],
    //   pasrsedSimilarDataLength: 0,
    //   pasrsedDifferentDataLength: 0,
    // });
  }

  const toggleUnregisteredRetailers = () => {
    setUnregisteredRetailersToggle(!unregisteredRetailersToggle)
    // this.setState({ unregisteredRetailersToggle: !this.state.unregisteredRetailersToggle })
  }

    return (
      <div>
        <div className="notification-list-button"><ListButton basePath={resources} /></div>
        <div className="so-form-container">
          <div className="so-form">

            <div className="so-input">
              <label>Notification Purpose<sup className="asterisk">*</sup></label>
              <input
                className="form-control"
                type="text"
                name="Purpose"
                value={soAppPurpose || ''}
                onChange={purposeChange}
              />
              {validationPurposeError &&
                <p className="so-input-error">Please enter a Purpose</p>
              }
            </div>

            <div className="so-input">
              <label>Notification Title<sup className="asterisk">*</sup></label>
              <input
                className="form-control"
                type="text"
                name="Title"
                value={soAppTitle || ''}
                onChange={titleChange}
              />
              {validationTitleError &&
                <p className="so-input-error">Please enter a title</p>
              }
            </div>

            <div className="so-input">
              <label>Notification Description<sup className="asterisk">*</sup></label>
              <textarea
                className="inapp-notification-description"
                name="description"
                maxLength="500"
                value={soAppDescription}
                onChange={descriptionChange}
              />
              {validateDescriptionError &&
                <p className="so-input-error">Please enter a description</p>
              }
              <p className="characters-remaining">{descCharLeft} characters remaining</p>
            </div>

            {/* <input type="file" id="file" onChange={this.handleFile} /> */}

            <div className="so-input">
              <label>Notification Send To<sup className="asterisk">*</sup></label>
              <select className="inapp-notification-sendto" name="type" value={type} onChange={selectHandleChange}>
                <option value="Country">All Sales Officer</option>
                <option value="SalesOfficer">A set of Sales Officer</option>
              </select>
            </div>


            {
            type === 'SalesOfficer' &&
              <div>
                <div className="csv-file-upload-container target-upload-container"><label>Upload File</label>
                  {/* <input type="file" accept=".csv" name="flies[]" /> */}
                  <input type="file" id="file" accept=".csv" onChange={handleFile} />
                  <div className="valid-file-upload">
                    <p>Instructions :</p>
                    <ul>
                      <li>Only CSV files are allowed with Comma as separator.</li>
                    </ul>
                  </div>
                  <div className="upload-file-format-download">
                    <p>To get upload file format. <a
                      href="https://navendor-global-production.s3-eu-west-1.amazonaws.com/fille_formats/so_in_app_notification.csv"
                      target="_blank">Click here</a> to download</p>
                  </div>
                </div>

                {
                  pasrsedSimilarDataLength > 0 ||
                    pasrsedDifferentDataLength > 0 ?
                    <div className="csv-result-container">
                      <label>CSV Result</label>
                      <div className="csv-result">
                        <div>
                          <p onClick={toggleUnregisteredRetailers}>
                            {pasrsedSimilarDataLength} sales officers found, {pasrsedDifferentDataLength} sales officers unregistered.
                            {pasrsedDifferentDataLength > 0 ? ' Click to view unregistererd sales officer' : ''}
                            {
                              pasrsedDifferentDataLength > 0 ?
                                <span className={unregisteredRetailersToggle ? `icon-arrow_down` : `icon-arrow_up`} />
                                : ''
                            }
                          </p>
                          {
                            pasrsedDifferentDataLength > 0 ?
                              <div className={unregisteredRetailersToggle ? `hide-unregistered` : `show-unregistered`}>
                                <React.Fragment>
                                  {
                                    unregisteredRetailers.map(item => (
                                      <p key={item.id}>{item.label}</p>
                                    ))
                                  }
                                </React.Fragment>
                              </div>
                              : ''
                          }
                        </div>
                      </div>
                    </div> :
                    ''
                }

                <label className="select-label">Choose Sales Officer<sup className="asterisk">*</sup> (Atleast select one Sales Officer)</label>
                <div className="select-retailer">
                  <Select
                    value={saleOffList}
                    onChange={handleChange}
                    options={saleOffNameSapCode}
                    isMulti
                  />
                  <button onClick={cancelClick}>Clear</button>
                </div>

              </div>
            }
          </div>
          {saveButtonDisabled &&
            <div className="so-save-button">
              <button className={(!soAppTitle || !soAppDescription || !soAppPurpose || validationTitleError
                || validateDescriptionError || validationPurposeError || (type === 'SalesOfficer' && !saleOffList)) ? 'disable-save' : ''}
                disabled={validationTitleError || validateDescriptionError || validationPurposeError || !soAppTitle
                  || !soAppDescription || !soAppPurpose || (type === 'SalesOfficer' && !saleOffList)}
                onClick={() => formSave()}>Save</button>
            </div>
          }

          {showLoader &&
            <div className="save-loader" />
          }
          {successMsg &&
            <div className="so-updated" >
              Successfully Created </div>
          }
          {errorMsg &&
            <div className="so-email-exist" >
              {errorMsgText}</div>
          }
        </div>
      </div>
    )
}

export default SoAppNotificationCreate;